import script from "./softProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./softProduct.vue?vue&type=script&setup=true&lang=js"

import "./softProduct.vue?vue&type=style&index=0&id=739d4385&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-739d4385"]])

export default __exports__